<i18n>
{
  "en": {
    "DemoTitle": "A virtual tour example"
  },
  "de": {
    "DemoTitle": "A virtual tour example"
  }
}
</i18n>
<template>
  <embed-viewer-route-view
    :url="'https://www.google.ch/maps?layer=c&sll=47.386071,8.521889&cid=828082437908676184&panoid=o2E6dSxV1RkAAAQJMtboeg&cbp=13,25.47,,0,0&q=the+chair+viadukt&ie=UTF8&hq=&hnear=&t=m&cbll=47.385882,8.521761&source=embed&ll=47.386071,8.521889&spn=0.006295,0.006295&output=svembed'"
    :title="$t('DemoTitle')"
    :can-go-back="canGoBack"
  ></embed-viewer-route-view>
</template>
<script>
export default {
  data() {
    return {
      canGoBack: false
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.canGoBack = !!from.name;
    });
  }
};
</script>